interface DrawerFabsProps {
  onOpenLeft: () => void;
  onOpenRight: () => void;
  isAnyOpen: boolean;
}

export const DrawerFabs = ({
  onOpenLeft,
  onOpenRight,
  isAnyOpen,
}: DrawerFabsProps) => {
  if (isAnyOpen) return null;

  return (
    <>
      <button
        type="button"
        onClick={onOpenLeft}
        className="fixed bottom-4 left-4 z-40 xl:hidden w-11 h-11 rounded-full btn-global-primary shadow-lg flex items-center justify-center transition-transform hover:scale-105 active:scale-95"
        aria-label="Open control panel"
      >
        <svg
          className="w-5 h-5 text-white"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
          />
        </svg>
      </button>

      <button
        type="button"
        onClick={onOpenRight}
        className="fixed bottom-4 right-4 z-40 xl:hidden w-11 h-11 rounded-full btn-global-primary shadow-lg flex items-center justify-center transition-transform hover:scale-105 active:scale-95"
        aria-label="Open client notifications"
      >
        <svg
          className="w-5 h-5 text-white"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"
          />
        </svg>
      </button>
    </>
  );
};
